import {
  birthdayDate,
  clubPrem,
  companyPolicy,
  createValidator,
  enrollmentEmail,
  firstName,
  gender,
  lastName,
  middleName,
  passwordCP,
  phoneNumberSignUpProfile,
  privacyPolicy,
  termsAndConditions,
} from './validation';

const userProfileSignupValidationFields = {
  birthdayDate: [birthdayDate],
  companyPolicy: [companyPolicy],
  email: [enrollmentEmail],
  firstName: [firstName],
  gender: [gender],
  lastName: [lastName],
  middleName: [middleName],
  SignUpPassword: [passwordCP],
  parent : [clubPrem],
  phone: [phoneNumberSignUpProfile],
  privacyPolicy: [privacyPolicy],
  userProfileTermsAndConditions: [termsAndConditions],
};

const userProfileSignupValidator = createValidator(userProfileSignupValidationFields);

const userProfileSignupValidation = values => {
  return userProfileSignupValidator(values);
};

export default userProfileSignupValidation;
